/**
 * External dependencies
 */
import { useBlockProps } from '@wordpress/block-editor';
import { EditorProvider } from '../wc_components/js/base/context';

import { previewCart, previewSavedPaymentMethods } from '../wc_components/js/previews';
/**
 * Internal dependencies
 */
import Block from './block';

const Edit = ({ attributes, setAttributes }) => {
	const { className } = attributes;
	const blockProps = useBlockProps();

	return (
		<div {...blockProps}>
			<EditorProvider
				isPreview={ true }
				previewData={ { previewCart, previewSavedPaymentMethods } }
			>
				<Block className={className} />
			</EditorProvider>
		</div>
	);
};

const Save = () => {
	return <div {...useBlockProps.save()} />;
};

export { Edit, Save };
